import React from "react";


class AppCollection extends React.Component {
    render() {
        let attribute = this.props.attribute

        return (
            <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2">
                {
                    attribute.map((item, idx) => (
                        <div key={item} className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 MuiGrid-grid-sm-12 
                    MuiGrid-grid-md-4 MuiGrid-grid-lg-4">
                            <a  href={item.href}>
                                <div className="listing-card STYLE1">
                                    <div className="listing-link" data-testid="undefined-card">
                                        <div className="listing-content show-action">
                                            <div className="badges"></div>
                                            <div className="content">
                                                <div>
                                                    <div className="icon-container">
                                                        <div className="image-container"><img className="icon"
                                                            src={item.imgsrc}
                                                            alt="Alpa" loading="lazy" /></div>
                                                    </div>
                                                    <div className="details-container">
                                                        <div className="category">{item.category}</div>
                                                        <div className="name" title="Alpa">{item.name}</div>
                                                        <div className="action">
                                                            <p>View details</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))
                }
            </div>
            
        );
    }
}


export default AppCollection;

